import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { Component, OnInit, ViewChild, afterNextRender } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { FiltroObterVinculosAgentesPublicos, ResultadoVinculosAgentesPublicos, VinculoAgentePublico, VinculosService } from 'src/app/services/vinculos.service';
import { removeDiacritics, getRightSubstring } from 'src/app/components/shared/string-utils';
import { CpfPipe } from 'src/app/components/shared/pipes/cpf.pipe';
import { CrudUtilService } from 'src/app/services/crud-util.service';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { EnumNivelAcesso } from 'src/app/components/shared/enums/nivel-acesso.enum';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { Message } from 'src/app/components/shared/message';

@Component({
    selector: 'app-buscar-agente-publico',
    templateUrl: './buscar-agente-publico.component.html',
    styleUrls: ['./buscar-agente-publico.component.scss']
})
export class BuscarAgentePublicoComponent extends FeriasBaseComponent implements OnInit {
    situacoesEfeitoFerias = [{ descricao: 'Ativa' }, { descricao: 'Encerrada' }];
    formFiltro: FormGroup;
    submetido = false;

    resultadoPesquisa: VinculoAgentePublico[];
    pesquisaRealizada = false;
    tamanhoPagina = 10;

    emProcessoDeLimpeza = false;

    selecaoUorgObrigatoria = false;
    obrigatoriedadeUorgPorNivelAcesso = false;

    private upagUnica = false;

    msgObrigatoriedadeCampos: string = Message.ERRO_PESQUISA_CAMPOS_OBRIGATORIOS_NAO_PREENCHIDOS;
    msgObrigatoriedadeCamposNivelAcessoUorgSubordinadas: string = Message.ERRO_PESQUISA_CAMPOS_OBRIGATORIOS_COM_UORG_NAO_PREENCHIDOS;

    @ViewChild('pTableResultado') pTableResultado: Table;

    constructor(
        private fb: FormBuilder,
        alertaMsgService: AlertMessageService,
        private vinculosService: VinculosService,
        private crudUtilService: CrudUtilService,
        private router: Router,
        private cpfPipe: CpfPipe,
        private segurancaService: SegurancaService
    ) {
        super(alertaMsgService);

        afterNextRender(() => {
            this.alterarTituloTemplate('Gerenciar Férias');
            this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
        });
    }

    ngOnInit(): void {
        this.clearMessages();
        this.initForm();
        this.carregarResultadoPrevio();

        //Verifica se o usuário é nível de acesso UORG e Subordinadas para definir a obrigatoriedade de seleção da UORG
        setTimeout(() => {
            this.segurancaService.userData$.subscribe(dadosUsuarioLogado => {
                this.obrigatoriedadeUorgPorNivelAcesso = '' + dadosUsuarioLogado.nivelAcesso.id === EnumNivelAcesso.UORG_SUBORDINADAS.id;
                this.atualizarObrigatoriedadeSelecaoUorg();
                if (dadosUsuarioLogado.codigoUorgSiape && !isNaN(dadosUsuarioLogado.codigoUorgSiape)) {
                    //Espera até o preenchimento do combo de UPAG para então selecionar a UORG do usuário logado
                    const selecionarUorg = () => {
                        if (this.formFiltro && this.formFiltro.controls['codigoUpag'].value) {
                            this.formFiltro.controls['codigoUorg'].setValue(Number(dadosUsuarioLogado.codigoUorgSiape));
                        } else {
                            setTimeout(() => {
                                selecionarUorg();
                            }, 100);
                        }
                    };
                    selecionarUorg();
                }
            });
        }, 100);
    }

    carregarResultado(resultado: VinculoAgentePublico[], resultadoSiapeFoiLimitado: boolean): void {
        this.resultadoPesquisa = resultado;
        if (resultado.length > 0) {
            setTimeout(() => {
                this.ajustarUsoTecladoGrid(this.pTableResultado);
            }, 100);

            if (resultadoSiapeFoiLimitado) {
                this.getAlertaMsgService().warn(Message.AVISO_QUANTIDADE_MAXIMA_REGISTROS_EXCEDIDA);
            }
        }
    }

    carregarResultadoPrevio(): void {
        const resultadoObtido = this.crudUtilService.obterResultadoObtido('BuscarAgentePublicoComponent');
        if (resultadoObtido) {
            this.carregarResultado(resultadoObtido, false);
        }
    }

    initForm(): void {
        const formSubmetido = this.crudUtilService.obterFormSubmetido('BuscarAgentePublicoComponent');

        //Resgata o preenchimento prévio do formulário (por exemplo, ao voltar da tela de Consultar Exercícios)
        if (formSubmetido) {
            this.formFiltro = formSubmetido;
        } else {
            this.formFiltro = this.fb.group({
                codigoOrgao: [null],
                codigoUpag: [null],
                codigoUorg: [null],
                cpf: [''],
                nome: [''],
                situacoesEfeitoFeriasSelecionadas: new FormControl<any[] | null>([{ descricao: 'Ativa' }])
            });
        }
    }

    onChangeOrgao(): void {
        this.upagUnica = false;
        this.atualizarObrigatoriedadeSelecaoUorg();
    }

    onOpcoesUpagCarregadas(evento: { quantidade: number; bloqueado: boolean }): void {
        this.upagUnica = evento?.quantidade === 1;
        this.atualizarObrigatoriedadeSelecaoUorg();
    }

    atualizarObrigatoriedadeSelecaoUorg(): void {
        const cpf = this.formFiltro.controls['cpf'];
        const nome = this.formFiltro.controls['nome'].value;
        const cpfPreenchidoEValido = !!cpf.value && cpf.valid;
        const nomePreenchido = typeof nome === 'string' && nome.trim() !== '';

        this.selecaoUorgObrigatoria = this.obrigatoriedadeUorgPorNivelAcesso || (this.upagUnica && !cpfPreenchidoEValido && !nomePreenchido);
    }

    pesquisar(): void {
        this.submetido = true;
        this.getAlertaMsgService().dismissAll();

        const params = this.formFiltro.value;

        //Possibilidades de consulta:
        //  1. CPF preenchido; ou
        //  2. Órgão e mais um outro campo; ou
        //  3. Nome e mais um outro campo.
        const situacoesEfeitoFeriasVazias = params.situacoesEfeitoFeriasSelecionadas.length === 0;
        const uorgObrigatoriaNaoPreenchida = this.selecaoUorgObrigatoria && !params.codigoUorg;
        const camposObrigatoriosNaoPreenchidos = !params.codigoOrgao && !params.codigoUpag && !params.codigoUorg && !params.cpf && (!params.nome || params.nome.trim() === '');
        const cpfNaoPreenchido = !params.cpf;
        const orgaoPreenchidoIsoladamente = !!params.codigoOrgao && !params.codigoUpag && !params.codigoUorg && (!params.nome || params.nome.trim() === '');
        const nomePreenchidoIsoladamente = !(!params.nome || params.nome.trim() === '') && !params.codigoOrgao && !params.codigoUpag && !params.codigoUorg;

        if (situacoesEfeitoFeriasVazias || uorgObrigatoriaNaoPreenchida || camposObrigatoriosNaoPreenchidos || (cpfNaoPreenchido && (orgaoPreenchidoIsoladamente || nomePreenchidoIsoladamente))) {
            if (this.obrigatoriedadeUorgPorNivelAcesso) {
                this.getAlertaMsgService().error(this.msgObrigatoriedadeCamposNivelAcessoUorgSubordinadas);
            } else {
                this.getAlertaMsgService().error(this.msgObrigatoriedadeCampos);
            }
            return;
        }

        if (this.formFiltro.valid && (!params.nome || params.nome.trim() === '' || params.nome.trim().length >= 1)) {
            const filtro: FiltroObterVinculosAgentesPublicos = {
                codigoOrgao: params.codigoOrgao ? parseInt(params.codigoOrgao) : null,
                codigoUpag: params.codigoUpag ? parseInt(params.codigoUpag) : null,
                codigoUorg: params.codigoUorg ? parseInt(params.codigoUorg) : null,
                cpf: params.cpf ? parseInt(params.cpf) : null,
                nome: params.nome && params.nome.trim() !== '' ? removeDiacritics(params.nome.trim()).toUpperCase() : null,
                situacao: params.situacoesEfeitoFeriasSelecionadas && params.situacoesEfeitoFeriasSelecionadas.length === 1 ? (params.situacoesEfeitoFeriasSelecionadas[0].descricao === 'Ativa' ? 1 : 0) : null
            };

            this.resultadoPesquisa = null;
            this.pesquisaRealizada = false;

            this.vinculosService.obterVinculosAgentesPublicos(filtro).subscribe((resultadoVinculosAgentePublico: ResultadoVinculosAgentesPublicos) => {
                this.pesquisaRealizada = true;

                if (resultadoVinculosAgentePublico && resultadoVinculosAgentePublico.servidores && resultadoVinculosAgentePublico.servidores.length > 0) {
                    //Ordenar pela situação para agrupar todos os ativos de uma pessoa juntos e primeiro
                    resultadoVinculosAgentePublico.servidores.sort((a, b) => {
                        if (a.situacaoVinculo === b.situacaoVinculo) {
                            return 0;
                        }
                        return a.situacaoVinculo ? -1 : 1;
                    });

                    this.carregarResultado(resultadoVinculosAgentePublico.servidores, resultadoVinculosAgentePublico.resultadoSiapeFoiLimitado);

                    this.resultadoPesquisa.forEach(registro => {
                        //Criacao das propriedades descricaoSituacaoVinculo, descricaoMatriculaCargo, descricaoOrgaoUpagUorg e descricaoCodigoSituacaoFuncional
                        (registro as any).descricaoSituacaoVinculo = registro.situacaoVinculo ? 'Ativo' : 'Encerrado';
                        (registro as any).descricaoMatriculaCargo = registro.matricula + ' - ' + registro.descricaoCargo;
                        //parseInt(getRightSubstring(registro.codigoUpag + "", 9))
                        (registro as any).descricaoOrgaoUpagUorg = registro.codigoOrgao + '/' + registro.codigoUpag.toString().padStart(5, '0') + '/' + registro.codigoUorg.toString().padStart(5, '0');
                        (registro as any).descricaoCodigoSituacaoFuncional = registro.regime + ' - ' + registro.descricaoSituacaoFuncional;

                        //Formatar campo CPF e criar propriedade cpfFormatado
                        (registro as any).cpfFormatado = this.cpfPipe.transform(registro.cpf);
                    });
                }
            });
        } else {
            this.formFiltro.markAllAsTouched();
        }
    }

    limpar(): void {
        this.emProcessoDeLimpeza = true; //para forçar o construtor dos combos de Órgão, UPAG e UORG

        this.getAlertaMsgService().dismissAll();
        this.formFiltro.reset();
        this.initForm();
        this.upagUnica = false;
        this.atualizarObrigatoriedadeSelecaoUorg();
        this.resultadoPesquisa = null;
        this.submetido = false;
        this.pesquisaRealizada = false;

        setTimeout(() => {
            this.emProcessoDeLimpeza = false;
        }, 10);
    }

    ver(vinculoSelecionado: any): void {
        //Guarda o estado atual da consulta
        this.crudUtilService.guardarEstadoPosConsulta('BuscarAgentePublicoComponent', this.formFiltro, this.resultadoPesquisa);

        const navigationExtras: NavigationExtras = {
            state: {
                data: vinculoSelecionado
            }
        };
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios'], navigationExtras);
    }

    filterOnInputChange(filterCallback, $event) {
        filterCallback($event.target.value);
    }

    filterOnInputBlankOrEnter(filterCallback, $event) {
        if ($event.target.value === '') {
            filterCallback($event.target.value);
        } else if ($event.keyCode === 13) {
            filterCallback($event.target.value);
        }
    }
}
